// Translation for da
export const da = {
        common: {
            save: 'Gem',
            cancel: 'Annuller',
            close: 'Luk',
            delete: 'Slet',
            edit: 'Rediger',
            activate: 'Aktivér',
            add: 'Tilføj',
            saving: 'Gemmer...',
            loading: 'Indlæser...',
            active: 'AKTIV',
            inUse: 'I Brug',
            test: 'Test',
            searchApps: 'Søg efter apps...',
            betaBanner: 'BETA - Tjeneste ikke tilgængelig endnu!'
        },
        header: {
            creditBalance: 'Saldo',
            minutes: 'MIN'
        },
        auth: {
            signIn: 'Log Ind',
            signUp: 'Registrer',
            username: 'Brugernavn',
            password: 'Adgangskode',
            continue: 'Fortsæt',
            noAccount: 'Har du ikke en konto?',
            hasAccount: 'Har du allerede en konto?',
            loginError: 'Login mislykket',
            invalidCredentials: 'Ugyldigt brugernavn eller adgangskode',
            rateLimited: 'For mange loginattempts. Vent venligst et øjeblik.',
            sessionExpired: 'Din session er udløbet. Brug venligst et nyt magisk link.',
            magicLinkInvalid: 'Loginlinket er ugyldigt eller udløbet.',
            magicLinkSuccess: 'Velkommen! Du er blevet logget ind.',
            magicLinkProcessing: 'Behandler login...',
            connectionError: 'Forbindelsesfejl. Prøv igen.'
        },
        profile: {
            myProgress: 'Mit Læringsfremmskridt',
            signOut: 'Log Ud',
            plan: 'Plan: '
        },
        settings: {
            title: 'Indstillinger',
            tabs: {
                uiSettings: 'UI-indstillinger',
                systemPrompt: 'Systemprompt',
                llmProfiles: 'LLM-profiler',
                ttsProfiles: 'TTS-profiler',
                language: 'Sprog',
            },
            uiSettings: {
                title: 'Brugerinterface',
                themeMode: 'Tematilustrering',
                darkMode: 'Mørk Tilstand',
                lightMode: 'Lys Tilstand',
                themeColor: 'Temafarve',
                themeColorDesc: 'Vælg accentfarve for knapper, ikoner og fremhævninger',
                background: 'Baggrund',
                backgroundDesc: 'Vælg en baggrund til dit arbejdsområde',
                selectBackgroundColor: 'Vælg Baggrundsfarve',
                backgrounds: {
                    cyberSchooling: 'Cyber Schooling',
                    focus: 'Fokus',
                    concentration: 'Koncentration',
                    relaxation: 'Afslapning',
                    lianas: 'Lianer',
                    color: 'Farve'
                },
                backgroundColors: {
                    deepDark: 'Dyb Sort',
                    darkGrey: 'Mørkegrå',
                    midnightBlue: 'Midnatblå',
                    indigo: 'Indigo',
                    darkTeal: 'Mørk Teal',
                    brown: 'Brun',
                    darkRed: 'Mørkrød',
                    deepPurple: 'Dyb Lilla',
                    pureWhite: 'Rent Hvidt',
                    softWhite: 'Blidt Hvidt',
                    lightGrey: 'Lysegrå',
                    paleBlue: 'Blegt Blå',
                    paleGreen: 'Blegt Grøn',
                    paleOrange: 'Blegt Orange',
                    lavender: 'Lavendel',
                    blueGrey: 'Blågrå'
                }
            },
            systemPrompt: {
                label: 'Systemprompt:',
                placeholder: 'Indlæser systemprompt...',
                emptyError: 'Systemprompt kan ikke være tom!',
                saveSuccess: '✓ Systemprompt gemt med succes!',
                loadError: 'Fejl ved indlæsning af systemprompt',
                saveError: 'Fejl ved gemning'
            },
            llmProfiles: {
                addButton: '+ Tilføj Ny Forbindelse',
                newConnection: 'Ny Forbindelse',
                editConnection: 'Rediger Forbindelse',
                emptyState: 'Ingen LLM-forbindelser tilgængelige. Klik nedenfor for at tilføje en.',
                loadingProfiles: 'Indlæser profiler...',
                nameLabel: 'Navn *',
                namePlaceholder: 'f.eks. OpenAI GPT-4',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'API Nøgle *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'Model *',
                modelPlaceholder: 'gpt-4, mistral-tiny, osv.',
                allFieldsRequired: 'Alle felter skal udfyldes!',
                saveSuccess: '✓ Profil gemt med succes!',
                deleteConfirm: 'Vil du virkelig slette "{name}"?',
                profileNotFound: 'Profil ikke fundet!',
                loadError: 'Fejl ved indlæsning af profiler',
                saveError: 'Fejl ved gemning',
                activateError: 'Fejl ved aktivering',
                deleteError: 'Fejl ved sletning',
                modelInfo: 'Model: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ Tilføj Ny Stemme',
                newVoice: 'Ny Stemme',
                editVoice: 'Rediger Stemme',
                emptyState: 'Ingen TTS-profiler tilgængelige. Klik nedenfor for at tilføje en.',
                loadingProfiles: 'Indlæser TTS-profiler...',
                nameLabel: 'Navn',
                namePlaceholder: 'f.eks. Min ElevenLabs Adam',
                providerLabel: 'Udbyder',
                providerPlaceholder: 'f.eks. ElevenLabs, OpenAI, Piper',
                providerPiper: 'Piper (Lokal)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'API Nøgle *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'Model ID *',
                modelIdPlaceholder: 'f.eks. eleven_monolingual_v1',
                voiceIdLabel: 'Stemme ID',
                voiceIdPlaceholder: 'f.eks. pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'Alle felter skal udfyldes!',
                saveSuccess: '✓ TTS-profil gemt med succes!',
                deleteConfirm: 'Vil du virkelig slette "{name}"?',
                loadError: 'Fejl ved indlæsning af TTS-profiler',
                saveError: 'Fejl ved gemning',
                activateError: 'Fejl ved aktivering',
                deleteError: 'Fejl ved sletning'
            },
            language: {
                title: 'Vælg Sprog',
                description: 'Vælg dit foretrukne sprog til brugergrænsefladen'
            },
        },
        chat: {
            ready: 'Klar',
            start: 'START',
            stop: 'STOP',
            initialMessage: 'Klik START for real-time samtale.',
            listening: 'Lytter...',
            speaking: 'Thorsten taler...',
            userLabel: 'Du',
            aiLabel: 'AI',
            modalTitle: 'Thorsten AI Chat',
            inputPlaceholder: 'Skriv en besked...',
            send: 'Send',
            loginRequired: 'Log ind for at bruge denne tjeneste.',
            loginButton: 'Log ind Nu',
            magicLinkRequired: 'Brug venligst et magisk link til login.',
            creditLimitError: 'Din timekonto er opbrugt. Opgrader din plan (Medium/Premium) for at fortsætte.',
            serviceDisabled: 'Chattjenesten er i øjeblikket ikke tilgængelig. Prøv venligst igen senere.'
        },
        notifications: {
            error: 'Fejl',
            success: 'Succes',
            info: 'Information',
            unknownError: 'Der opstod en ukendt fejl'
        },
        cookie: {
            message: 'Dette websted bruger cookies til at give dig den bedst mulige brugeroplevelse.',
            accept: 'Acceptér'
        },
        curriculum: {
                buttonLabel: 'Læreplan',
                buttonTitle: 'Vis læreplanindhold',
                modalTitle: '{app} Læreplan',
                sections: {
                    topic: 'Læreplanemne',
                    explanation: 'Børnevenlig forklaring',
                    studentProfile: 'Elevprofil'
                },
                topic: {
                    empty: 'Der er ikke knyttet noget læreplanemne til denne mikro-app i backend.',
                    missingDetail: 'Detaljerede læreplansdata for denne mikro-app er endnu ikke tilgængelige i backend.',
                    learningGoals: 'Læringsmål',
                    prerequisites: 'Forudsætninger',
                    unitLabel: 'Enhed',
                    durationLabel: 'Varighed',
                    difficultyLabel: 'Sværhedsgrad',
                    hours: 't',
                    minutes: 'min'
                },
                explanation: {
                    empty: 'Ingen børnevenlig forklaring tilgængelig.',
                    loadingPrepare: 'AI forbereder forklaringen',
                    loadingExplain: 'AI forklarer emnet i børnevenligt sprog',
                    requestFailed: 'Børnevenlig forklaring kunne ikke genereres.'
                },
                studentProfile: {
                    country: 'Land',
                    region: 'Stat / Region',
                    schoolType: 'Skoletrin',
                    grade: 'Klasse',
                    noContext: 'Ingen elevkontekst tilgængelig.',
                    childProfileNotFound: 'Der blev ikke fundet nogen elevprofil i backend for den aktuelle login.',
                    loginProfileIncomplete: 'Loginprofilen indeholder endnu ikke en komplet elevkontekst.',
                    educationContextNotFound: 'En elevprofil blev fundet, men der er ikke angivet nogen læreplantilknytning.',
                    noToken: 'Ingen logget elev fundet.'
                },
                errors: {
                    signInRequired: 'Log venligst ind for at se læreplanen.',
                    appIdMissing: 'App-id mangler.',
                    loadFailed: 'Kunne ikke indlæse læreplansdata.'
                }
            }
    };
